import React from "react";
//Material imports
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade"; //style={{ color: contrastColour, backgroundColor: primaryColour }}

var replaceParagraphs = function replaceParagraphs(text) {
  try {
    var body = text;

    if (body.includes("<p>")) {
      body = body.replace(new RegExp("<p>", "g"), "<span>");
      body = body.replace(new RegExp("</p>", "g"), "</span>");
    }

    return body;
  } catch (_unused) {
    return text;
  }
};

var SlideBody = function SlideBody(_ref) {
  var classes = _ref.classes,
      headline = _ref.headline,
      shouldAnimate = _ref.shouldAnimate,
      color = _ref.color;
  var body = replaceParagraphs(headline);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.slideBodyContainer
  }, /*#__PURE__*/React.createElement(Fade, {
    in: true,
    timeout: 400,
    style: {
      transitionDelay: "0.6s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    className: classes.bodyText,
    component: "span",
    style: {
      color: color
    }
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: body
    }
  }))));
};

var styles = {
  slideBodyContainer: {
    justifyContent: "center",
    display: "flex",
    flex: 1,
    marginLeft: 20,
    marginRight: 20,
    flexDirection: "column"
  },
  bodyText: {
    overflow: "auto"
  }
};
export default withStyles(styles)(SlideBody);